<template>
    <div class="row q-col-gutter-xl">
        <div class="col col-12">
            <div v-html="instructions" class="instructions"></div>
            <div class="text-center q-py-md">
                <q-btn
                    type="a"
                    :href="redirect_url"
                    :disabled="!redirect_url"
                    :loading="loading"
                    color="black"
                >
                    CONTINUE TO&nbsp;
                    <q-icon name="finmo" size="xl" color="white"/>
                </q-btn>
            </div>
            <div class="text-left q-py-md text-negative" v-if="!redirect_url && !loading">
                Oops! We couldn't reach Finmo... Please refresh the page to try again later or use another payment method.
            </div>
        </div>
    </div>
</template>
<script>

import Transfer from "Modules/Transfer/resources/models/Transfer"

export default {
    name: "FinmoM1",
    props: {
        instructions: {
            type: String,
            default: ''
        },
        fee: {
            type: Number,
            default: 0
        },
        transfer: {
            type: Object,
            default: ()=>{}
        },
        id: {
            type: Number,
            default: 0
        }
    },
    computed: {
        total_amount() {
            return Number(this.transfer.amount + this.fee)
        },
    },
    data() {
        return {
            loading: false,
            redirect_url: ''
        }
    },
    methods: {
        paymentViaFinmo(reference) {
            this.loading = true
            new Transfer({reference}).paymentViaPaymentMethod('finmo',({redirect_url}) => {
                this.redirect_url = redirect_url
                this.loading = false
            }).catch(error => {
                switch(error.status) {
                    case 419:
                        this.$emit('error', {'id': this.id})
                        break
                    default:
                        this.$q.notify({
                            message: 'Error connecting Finmo. Please contact Rebit Support.',
                            color: 'negative',
                            icon: 'fa fa-exclamation-triangle'
                        })
                }
                this.loading = false
            })
        }
    },
    mounted() {
        this.paymentViaFinmo(this.transfer.reference)
    },
    components: {},
}
</script>
<style scoped>
    .instructions ul{
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
